import { tokenizeColumnKey } from './tokenizeColumnKey'

// Whole-word tokens that mark a column as identifier-like: "borrowerId",
// "company_id", "apiKey", "apiVersion" all tokenize to include one of these.
const NOWRAP_WORDS = new Set([
  'id',
  'ext',
  'key',
  'version',
  'api',
  'timestamp',
  'timestamps',
])

// The backend (verified against openapi/*.yml in the peach repo) has ~90
// distinct "*At" event-timestamp fields (createdAt, deletedAt, archivedAt,
// canceledAt, chargedOffAt, statusUpdatedAt, ...) and ~150 "*Date" fields
// (startDate, dueDate, effectiveDate, dateOfBirth, ...) — far too many to
// enumerate, and new ones land with every spec change. A trailing "at"
// token or any "date" token covers the convention generally. Because
// tokenizeColumnKey() splits on whole words, this doesn't false-positive on
// "update"/"validate" (their tokens are "update"/"validate", never "date"),
// and "at" must be its own token — "seat" and "combat" don't split into a
// trailing "at".
const isTimestampLike = (tokens: Array<string>): boolean =>
  tokens[tokens.length - 1] === 'at' || tokens.includes('date')

/**
 * Whether a column's cells should render with `white-space: nowrap` by
 * default — identifier fields (id/ext/key/version/api/timestamp) and
 * timestamp fields (anything ending in "At" or containing "Date") read
 * better unbroken than wrapped. Matches whole words only, so "extension"
 * and "rating" are not caught by "ext" or the "at" in "createdAt".
 */
export const isNoWrapColumn = (columnKey: string | undefined): boolean => {
  if (!columnKey) return false

  const tokens = tokenizeColumnKey(columnKey)

  return (
    tokens.some((token) => NOWRAP_WORDS.has(token)) || isTimestampLike(tokens)
  )
}
